module.exports = __webpack_public_path__ + "img/sddzyidd.8e98fb1f.png";